// src/Home.js
import React from "react";
import './SideBar.css';
import {NavLink} from "react-router-dom";

function SideBar({blueHome, position, blueAdmin, blueEdit, blueStep,blueCharts,blueСumulativeCharts, blueTeam, blueGameProcess, blueGames, isAdmin}) {

    return (
        <header style={position}>
            <nav>
                <NavLink to={"/home"} style={blueHome}>Шаги</NavLink>
                {/*<NavLink to={"/edit"} style={blueEdit}>Редактирование пунктов</NavLink>*/}
                {/*<NavLink to={"/additional"} style={blueAdmin}>Столбчатый график</NavLink>*/}
                <NavLink to={"/steps"} style={blueStep}>Процесс</NavLink>

                {/* Показывать только администраторам */}
                {isAdmin && (
                <>
                    <NavLink to={"/Charts"} style={blueCharts}>Показатели по шагам</NavLink>
                    <NavLink to={"/СumulativeCharts"} style={blueСumulativeCharts}>Общие показатели</NavLink>
                    <NavLink to={"/Team"} style={blueTeam}>Команды</NavLink>
                    <NavLink to={"/GameProcess"} style={blueGameProcess}>Сводка</NavLink>
                   {/* <NavLink to={"/Games"} style={blueGames}>Игра</NavLink>*/}                    
                </>
                )}

                <NavLink to="/logout">Выход</NavLink>
            </nav>
        </header>
    );
}

export default SideBar;
